import { IGif } from '@giphy/js-types'
import React, { useRef } from 'react'
import { useChannelGifs } from 'shared/api/channels'
import SharedCarousel from 'shared/components/carousel/carousel'
import Observer from 'shared/components/observer'
import SharedVideoPreview from 'shared/components/video-preview-thumbnail'
import { IChannel } from 'shared/types/channel'
import styled from 'styled-components'
import createPlaceholderGif from '../gif-skeleton'

const MAX_CAROUSEL_ITEMS = 3
const MARGIN = 10

const getItemWidth = (width: number) => {
    const margin = (MAX_CAROUSEL_ITEMS - 1) * MARGIN
    return Math.floor((width - margin) / MAX_CAROUSEL_ITEMS)
}

const VideoPreview = styled(SharedVideoPreview)`
    display: inline-block;
    margin-bottom: ${MARGIN}px;
    margin-right: ${MARGIN}px;
    &:nth-${`child(${MAX_CAROUSEL_ITEMS}n)`} {
        margin-right: 0;
    }
`

const Carousel = styled(SharedCarousel)`
    margin-bottom: 0;
`

type Props = {
    title: string
    titleUrl: string
    width: number
    className?: string
    hideAttribution?: boolean
    channel: IChannel
}

const VideoPaginationCarousel = ({
    channel,
    title,
    titleUrl,
    width,
    className = '',
    hideAttribution = false,
}: Props) => {
    const placeholder = useRef(createPlaceholderGif({ title: ' dummy ' }))
    const [gifs = [placeholder.current], fetchGifs] = useChannelGifs(channel, 'videos')
    const itemWidth = getItemWidth(width)
    const onNavigate = async ({ currentIndex, totalPages }) => {
        if (totalPages === currentIndex + 1) {
            fetchGifs()
        }
    }
    return (
        <Observer onVisible={fetchGifs} fireOnce>
            <Carousel
                maxBlocks={MAX_CAROUSEL_ITEMS}
                title={title}
                titleUrl={titleUrl}
                className={className}
                onNavigate={onNavigate}
            >
                {gifs.map((gif: IGif) => (
                    <VideoPreview key={gif.id} gif={gif} width={itemWidth} hideAttribution={hideAttribution} />
                ))}
            </Carousel>
        </Observer>
    )
}

export default VideoPaginationCarousel
